import { render, staticRenderFns } from "./MassivePatientsCreation.vue?vue&type=template&id=b8bf0842&lang=pug"
import script from "./MassivePatientsCreation.vue?vue&type=script&lang=js"
export * from "./MassivePatientsCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports